import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

type CarouselItem = {
  image: string;
  title: string;
  description: string;
};

type SwiperCarouselSectionProps = {
  heading?: string;
  items: CarouselItem[];
  add_background?: boolean;
  add_bottom_border?: boolean;
};

export default function SwiperCarouselSection({
  heading,
  items,
  add_background = false,
  add_bottom_border = false,
}: SwiperCarouselSectionProps) {
  const content = (
    <>
      {heading && (
        <h2 className="text-3xl md:text-4xl font-bold text-primary-700 mb-8">
          {heading}
        </h2>
      )}
      <div className={add_bottom_border ? "pb-8 border-b border-gray-200" : ""}>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          loop={true}
          className="rounded-2xl overflow-hidden [&_.swiper-button-next]:!text-gray-500 [&_.swiper-button-prev]:!text-gray-500 [&_.swiper-button-next::after]:!text-gray-500 [&_.swiper-button-prev::after]:!text-gray-500"
        >
          {items.map((item, idx) => (
            <SwiperSlide key={idx}>
              <div className="flex flex-col md:flex-row items-center gap-8 h-[400px] w-full bg-white rounded-2xl overflow-hidden p-4">
                <div className="flex-1 flex items-center justify-center h-full">
                  <Image
                    src={item.image}
                    alt={item.title}
                    width={500}
                    height={400}
                    className="object-cover w-full h-[300px] md:h-full rounded-2xl"
                  />
                </div>
                <div className="flex-1 flex flex-col justify-center items-start h-full text-left gap-4">
                  <h3 className="text-2xl md:text-3xl font-bold text-primary-800">
                    {item.title}
                  </h3>
                  <p className="text-base md:text-lg text-gray-700">
                    {item.description}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );

  if (add_background) {
    return (
      <section className="w-screen relative left-1/2 right-1/2 -mx-[50vw] bg-gradient-to-b from-[rgba(237,237,249,0)] to-[#DEE5E8] py-12">
        <div
          className="absolute left-0 bottom-0 w-[300px] h-[300px] bg-no-repeat bg-left-bottom bg-contain pointer-events-none"
          style={{
            backgroundImage: "url(/images/left-corner-supergrafis.png)",
          }}
        />
        <div className="container max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          {content}
        </div>
      </section>
    );
  }

  return <div className="w-full">{content}</div>;
}
